import { rankingItems } from '@/mocks/home';

export default function SectionRanking() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
    return 'ri-subtract-line text-secondary-500';
  };

  return (
    <section id="ranking" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-trophy-line text-accent-500 mr-2"></i>
          热播榜单
        </h2>
        <div className="max-w-[720px] mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.title}
                className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 hover:bg-background-100 cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <span
                  className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </div>
                  <div className="text-xs text-secondary-500">{item.category}</div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-sm font-heading font-bold text-primary-600">{item.heat}</span>
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={getTrendIcon(item.trend)}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}